const customRules = {
  pageName: 'Benutzerdefinierte Regeln',
  btnCreate: 'Erstellen',
  form: {
    header: {
      create: {
        title: 'Benutzerdefinierte Regeln',
      },
      update: {
        title: 'Benutzerdefinierte Regeln',
      },
    },
    information: {
      details: {
        header: 'Details',
        fields: {
          name: 'Name',
          type: {
            name: 'Typ',
            values: {
              tripPriority: 'Fahrtpriorität',
              driverPriority: 'Fahrerpriorität',
              passengerPreferences: 'Fahrgastpräferenzen',
            },
          },
          passengerRuleType: {
            name: 'Regeltyp',
            options: {
              passengers: 'Fahrgäste',
              drivers: 'Fahrer',
              vehicles: 'Fahrzeuge',
              passengersAndDrivers: 'Fahrgast & Fahrer',
            },
          },
          source: {
            name: 'Quelle',
            values: {
              internal: 'Fahrgastprofile',
              integration: 'Gästebuchungen',
            },
          },
        },
      },
      preference: {
        header: 'Einstellungen',
        fields: {
          passenger: 'Fahrgast',
          passengers: 'Fahrgäste',
          preferenceType: {
            name: 'Präferenztyp',
            values: {
              rideTogether: 'Gemeinsam fahren',
              rideApart: 'Getrennt fahren',
              preferredDriver: 'Bevorzugter Fahrer',
              excludedDriver: 'Ausgeschlossener Fahrer',
              strictDriver: 'Strenger Fahrer',
              preferredVehicle: 'Bevorzugtes Fahrzeug',
              excludedVehicle: 'Ausgeschlossenes Fahrzeug',
            },
          },
          drivers: 'Fahrer',
          driverPreferenceType: {
            name: 'Präferenztyp',
          },
          vehicleBy: {
            name: 'Fahrzeug von',
            values: {
              makeAndModel: 'Fahrzeugmarke/Modell',
              name: 'Fahrzeugname',
            },
          },
          vehicleMake: 'Fahrzeugmarke',
          vehicleModels: 'Fahrzeugmodelle',
          vehicleNames: 'Fahrzeugnamen',
          frequency: {
            name: 'Frequenz',
            values: {
              always: 'Immer',
              specificRange: 'Spezifischer Bereich',
            },
          },
          dateFrom: 'Datum von',
          dateTo: 'Datum bis',
          timeFrom: 'Zeit von',
          timeTo: 'Zeit bis',
          weekdays: 'Wochentage',
          direction: {
            name: 'Richtung',
            values: {
              both: 'Von & Bis',
              pickup: 'Von',
              dropoff: 'Bis',
            },
            warningNoLocation: 'Wenn kein Standort ausgewählt ist, trennt die Auswahl „Richtung: Von/Nach“ automatisch Abschnitt A und Abschnitt B.',
          },
          location: 'Standort',
          pickupOrder: {
            name: 'Abholauftrag festlegen',
          },
        },
        actions: {
          add: '+ Präferenz hinzufügen',
          addPassenger: 'Hinzufügen',
        },
      },
      priority: {
        header: 'Datensatz {{count}}',
        recordHeader: 'Datensatz',
        scoreLabel: 'Punkte',
        fields: {
          attributes: 'Eigenschaften',
          areas: 'Zonen',
          profiles: 'Profil',
        },
        btnAddPriority: {
          label: '+ Datensatz hinzufügen',
          tooltip: 'Eine neue Datensatzebene hinzufügen',
        },
      },
    },
    footer: {
      btnSubmit: {
        create: 'Einreichen',
        submitAndCreate: 'Senden und erstellen',
        update: 'Einreichen',
      },
    },
  },
  table: {
    headers: {
      name: 'Name',
      type: 'Typ',
      priority: 'Priorität',
      record: 'Datensatz',
      value: 'Wert',
      score: 'Punkte',
      passengerRuleType: 'Regeltyp',
    },
    filters: {
      recordType: 'Datensatz',
    },
    actions: {
      delete: {
        header: 'Löschen',
        modal: {
          header: 'Benutzerdefinierte Regeln löschen',
          body: 'Sie sind dabei, {{num}} Regeln zu löschen.',
        },
        toast: {
          success: 'Erfolg!',
          error: 'Fehler!',
        },
      },
    },
    tabs: {
      tripsRules: 'Fahrtregeln',
      driversRules: 'Fahrerregeln',
      passengersRules: 'Fahrgastpräferenzen',
    },
    toolTip: {
      noPermission: 'Aktion nicht zulässig: Berechtigung erforderlich',
    },
  },
  create: {
    toastSuccess: 'Erfolg!',
    toastError: 'Scheitern',
    toastValidationMessage: 'Bitte fügen Sie Attribute hinzu',
    errorConflict: {
      title: 'Konflikt mit Fahrgastregel',
      body: 'Es besteht ein Konflikt mit der Regel, die Sie erstellen möchten. Diese Fahrgäste sind bereits einer anderen Regel für denselben Zeitraum zugewiesen.',
    },
  },
  edit: {
    toastSuccess: 'Erfolg!',
    toastError: 'Scheitern',
    toastValidationMessage: 'Bitte fügen Sie Attribute hinzu',
    errorConflict: {
      title: 'Konflikt mit Fahrgastregel',
      body: 'Es besteht ein Konflikt mit der Regel, die Sie aktualisieren möchten. Diese Fahrgäste sind bereits einer anderen Regel für denselben Zeitraum zugewiesen.',
    },
  },
};

export default customRules;
